<template>
    <div>
        <el-dialog v-model="questionShow" :close-on-click-modal="false" title="Tips" width="500" :show-close="false"
            @click.stop="popup">
            <template #header>
                <div class="header">
                    <div>试题详情</div>
                    <!-- <div class="text_small">弹题是为了帮助同学们巩固知识点，不会影响到大家作业和考试成绩。</div> -->
                </div>
                <div class="close_icon cursor_pointer" @click="closePopup">
                    <el-icon :size="24">
                        <Close />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content">
                <div class="content scroll_y hidden_scroll">
                    <!-- 单选题 -->
                    <choice :questionInfo="topicInfo"
                        v-if="topicInfo.questionTypeId == 1 || topicInfo.questionTypeId == 9" :showAnswer="true">
                    </choice>
                    <!-- 多选题 -->
                    <multipleChoice :questionInfo="JSON.stringify(topicInfo)" v-else-if="topicInfo.questionTypeId == 2" :showAnswer="true">
                    </multipleChoice>
                    <!-- 判断题 -->
                    <trueOrFalse :questionInfo="topicInfo"
                        v-else-if="topicInfo.questionTypeId == 4 || topicInfo.questionTypeId == 11" :showAnswer="true"></trueOrFalse>
                    <!-- 判断题 -->
                    <fillIn :questionInfo="topicInfo"
                        v-else-if="topicInfo.questionTypeId == 3 || topicInfo.questionTypeId == 14" :showAnswer="true">
                    </fillIn>
                    <!-- 排序题 -->
                    <sort :questionInfo="topicInfo"
                        v-else-if="topicInfo.questionTypeId == 6 || topicInfo.questionTypeId == 15" :showAnswer="true">
                    </sort>
                    <!-- 文本解答题 -->
                    <textAnswer :questionInfo="topicInfo"
                        v-else-if="topicInfo.questionTypeId == 7 || topicInfo.questionTypeId == 13 || topicInfo.questionTypeId == 16 || topicInfo.questionTypeId == 17" :showAnswer="true">
                    </textAnswer>
                    <!-- 综合解答题 -->
                    <comprehensiveAnswer :questionInfo="topicInfo"
                        v-else-if="topicInfo.questionTypeId == 99 || topicInfo.questionTypeId == 101 || topicInfo.questionTypeId == 102 || topicInfo.questionTypeId == 103" :showAnswer="true">
                    </comprehensiveAnswer>
                    <!-- 信息匹配题 -->
                    <informationMatch :questionInfo="topicInfo" v-else-if="topicInfo.questionTypeId == 32" :showAnswer="true">
                    </informationMatch>
                    <composition :questionInfo="topicInfo" v-else-if="topicInfo.questionTypeId == 21 || topicInfo.questionTypeId == 22" :showAnswer="true"></composition>
                    <div class="flex flexcolumn Flexjustify empty_question" v-else>
                        <moe-empty url="development_icon.png" emptyText="更多题型开发中"></moe-empty>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import choice from '../testPaper/choice.vue';
import multipleChoice from '../testPaper/multipleChoice.vue';
import trueOrFalse from '../testPaper/trueOrFalse.vue';
import fillIn from '../testPaper/fillIn.vue';
import sort from '../testPaper/sortNew.vue';
import textAnswer from '../testPaper/textAnswer.vue';
import comprehensiveAnswer from '../testPaper/comprehensiveAnswer.vue';
import informationMatch from '../testPaper/informationMacth.vue';
import composition from '../testPaper/composition.vue';
export default {
    name: "GjkcH5Agreement",
    components: {
        choice, multipleChoice, sort, trueOrFalse, fillIn, textAnswer, comprehensiveAnswer, informationMatch,composition
    },
    // props: {
    //     videoQuestionInfo: {}
    // },

    data() {
        return {
            questionShow: false,
            topicInfo: {},
            videoQuestionInfo: {},
        };
    },

    mounted() {

    },

    methods: {
        popup() { },
        closePopup() {
            this.questionShow = false;
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 20px 20px 10px 10px;
    padding: 0;
    width: 786px;
    // max-height: 530px;
    position: relative;
}

:deep(.el-dialog__header) {
    position: relative;
}

.header {
    // text-align: center;
    // font-weight: bold;
    font-size: 20px;
    color: #111111;
    padding: 20px 20px 0;
    // line-height: 60px;
    // border-bottom: 1px solid rgba(36, 35, 36, 0.1);

    .text_small {
        font-size: 16px;
        color: #999999;
    }
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
}

.dialog_content {
    .content {
        padding: 20px 20px;
        font-size: 14px;
        color: #666666;
        line-height: 28px;
        min-height: 450px;
        max-height: 500px;
        overflow: auto;
        box-sizing: border-box;

        .empty_question {
            min-height: 450px;
        }
    }
}
</style>